import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import { navtoggle } from "../../../store/actions/AuthActions";
import appLogo from "../../../images/Login-img.png";
import newLogo from "../../../icons/logo/logo_transparent_background_text.png";
// import appLogo from "../../../images/appLogo.png";

function NavLogoSection() {
  const { openMenuToggle } = useContext(ThemeContext);

  const dispatch = useDispatch();

  const sideMenu = useSelector((state) => state.sideMenu);

  const handleToogle = () => {
    dispatch(navtoggle());
  };

  return (
    <div className="nav-header">
      <Link
        to="#"
        className="brand-logo d-flex flex-column align-items-center justify-content-center"
      >
        <img
          src={newLogo}
          alt="appLogo"
          style={{
            height: "50px",
            width: "80px",
            marginTop: "5px",
            marginLeft: "28px",
          }}
        />

        {!sideMenu && (
          <span
            className="d-none d-lg-block "
            style={{
              fontSize: "10px",
              fontWeight: "600",
              verticalAlign: "middle",
              color: "#000000",
            }}
          >
            Medical Business Solutions by AMG
          </span>
        )}
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          handleToogle();
          openMenuToggle();
        }}
      >
        <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
          <span className="line" style={{ backgroundColor: "#000000" }}></span>
          <span className="line" style={{ backgroundColor: "#000000" }}></span>
          <span className="line" style={{ backgroundColor: "#000000" }}></span>
        </div>
      </div>
    </div>
  );
}

export default NavLogoSection;
